export * from './ProductCardV2Heading';
